exports = module.exports = require("../../../../../../legacy/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#ad-map-cnt {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n#ad_map {\n  width: 100%;\n}\n#ad_map canvas {\n  left: 0;\n}", ""]);

// exports
